import React from "react";
import FormnavBar from "../../../components/common/wizard_navbar";
import WizardLeft from "../../../components/common/wizard_left";
import services from "../../../services";
import $ from "jquery";
import moment from "moment";
import { withRouter } from "react-router-dom";

import { toast } from "react-toastify";
import { Row } from "antd";
import IVVFrom from "./IVVFrom";
import WizardVínica from "./WizardVínica";
import VínicaRightPanel from "./rightPanel/VínicaRightPanel";

import HistoryPanel from "./histroyPanel";
import Checkbox from "antd/es/checkbox";
const queryString = require("query-string");

const parcel = [];

const mandatoryFields = {
    mainForm: [
        // "designacaoSocial",
        // "numeroEntrepostoFiscal",
        // "codigoPostalExtenso",
        // "idAtividade",
        // "idEntreposto",
        // "coddis",
        // "codcon",
        // "codfrg",
        // "morada",
    ],
    owner: [
        // "codEntidade",
    ],
};

/*
    owner verbal                0
    owner documental            1
                
    primary user verbal         2
    primary  user documental    3
    non primary user            4

    error                 9                           
*/

const createIntalacaoPayload = [
    "idInstalacaoVinica",
    //"designacaoSocial",
    "codigoIVV",
    "morada",
    "lugar",
    //"codigoPostalExtenso",
    "coddis",
    "codcon",
    "codfrg",
    "idAtividade",
    "idTipoInstalacao",
    "checkbox",
    //"idEntreposto",
    "idEstado",
    "areaCoberta",
    "geocodigo",
    //"numeroEntrepostoFiscal",
    "numeroLicIndustrial",
    "telefone",
    //"fax",
    //"ano",
    "dataCriado",
    "dataModificado",
    "instalacaoVinica",
    "observacoes",
    "entreposto",
    //"total",    //0
    "idUtilizadorInstalacao", // 0
    "codigoPostal",
    "codEntrFiscal",
    "DICOFRE",
    "criadoPor",
    "Etar",
    "LicenciamentoIndustrial",
    "idAtive",
    "idTipoInst",
    "localArmazenagem",
    "loggedUser"
];

const owner = [
    "codEntidade", // owner codEntidade
    "nome", //owner nome
    "ProprietarioPrincipal", //0,1
    "TipoIdentificacao",
];

const tipoInstalacaoCheckboxes = {
    Vinificacao: 1,
    Armazenamento: 2,
    ArmazenamentoProdutocabado: 4,
    Engarrafamento: 5,
};

const atividadesCheckboxes = {
    Armazenista: 4,
    Engarrafador: 5,
    Exportador_Importador: 6,
    Produtor: 7
}

const checkboxCheck = {
    1: "Vinificacao",
    2: "Armazenamento",
    4: "ArmazenamentoProdutocabado",
    5: "Engarrafamento",
};

let combolistrequest = {
    Filters: null,
    SortBy: null,
    IsSortTypeDESC: true,
    IsPagination: false,
    Page: 2,
    PageSize: 2,
};

class InserirInstalacaoVínica extends React.Component {
    /* Primeiro passo na acomodação da classe */

    constructor(props) {
        super(props);
        this.state = {
            data: {},
            all_list: {},
            id: "",
            sel_nev: "Dadosgerais",
            headName: null,
            formData: {},
            params: {},
            AllVisiable: {},
            AllEnable: {},
            checkMandatoryFields: false,
            VasilhaData: {},
            historyToggle: false,
            displayData: {
                Utilizadores: [],
                Instalação: [],
            },
            owner: {},
            IdenUser: {},
            isInEdit: false,
            allVasilha: [],
            allCapacidades: [],
            allUser: [],
            capacidade: {},
            vasilhaOwners: [],
            leakage: 0,
            vasilhaUserArray: [],
        };
    }

    triggerRender = () => {
        // This will trigger the render function to execute one more time
        this.forceUpdate();
    }

    /* Esta é a primeira etapa após o construxctor para carregar este componente  */

    componentDidMount() {
        let isInEdit = false;
        console.log("insert", this.props);
        const parsed = queryString.parse(this.props.location.search);
        let headName = "Inserir Instalação Vínica";
        console.log("the parsed action gave me rrr", parsed);
        console.log("did mount worked");
        if (parsed.idInstalacao) isInEdit = true;
        console.log("00011 call 1");
        this.setState({
            headName,
            params: parsed,
            id: parsed.id,
            isInEdit,
        });
       //this.getAllLIst();
       this.getAllVasilha()
        if (Object.keys(parsed).length > 0) {
            this.getIVVFormdetails(parsed);
        }
        // if(!parsed.idInstalacao){
        //     this.Inactiva();
        // }
        
    }

    componentDidUpdate(prevProps) {
        if (
            prevProps.location.search !== this.props.location.search &&
            this.props.location.search === ""
        ) {
            this.props.history.push({
                pathname: "/instalacaovinica",
            });
        }
    }

    isEnable = (name) => {
        let AllEnable = { ...this.state.AllEnable };

        if (AllEnable[name] === true || AllEnable[name] === false)
            return AllEnable[name] ? false : true;
        else return false;
    };
    isVisiable = (name) => {
        let AllVisiable = { ...this.state.AllVisiable };
        if (AllVisiable[name] === true || AllVisiable[name] === false) {
            return AllVisiable[name];
        } else return true;
    };

    Inactiva = (status) => {
        let AllEnable = { ...this.state.AllEnable };
        let AllVisiable = { ...this.state.AllVisiable };
        let full = false;
        if (status === "I") {
            full = true;
        }
        AllVisiable.btnCalculaDados = false;
        AllEnable.geocod = false;
        AllEnable.numparant = false;
        AllEnable.sitdeclar = false;
        AllEnable.desparc = false;
        AllEnable.pontuacao = false;
        AllEnable.dtultvist = false;
        AllEnable.codlitigio = false;
        AllEnable.fatordporto = false;
        AllEnable.areaprojectada = false;
        AllEnable.anoplantacao = false;
        AllEnable.idclasseplant = false;
        AllEnable.pontuacao = full;
        AllEnable.idclasseplant = false;
        AllEnable.designacaoSocial = false;

        AllEnable.bacelosileg = false;
        AllEnable.enxertoS1ILEG = false;
        AllEnable.videiraS2ILEG = false;
        AllEnable.videiraS3ILEG = false;
        AllEnable.videiraS4A25ILEG = false;
        AllEnable.videirasmaioR25ILEG = false;

        AllEnable.pcttinta = false;
        AllEnable.pctbranca = false;
        AllEnable.pctrose = false;
        AllEnable.pctmoscatel = false;

        AllEnable.compasso = false;
        AllEnable.densidade = false;
        AllEnable.prctLss3AndFailures = false;
        AllEnable.prctfaults = false;
        AllEnable.pesmaioR3 = false;
        AllEnable.pesmenoR3 = false;
        AllEnable.pesilegais = false;
        AllEnable.pestotals = false;
        AllEnable.pesramleg = false;
        AllEnable.falhasram = false;
        AllEnable.pesfalileg = false;
        AllEnable.pesfalleg = false;
        AllEnable.pescastasnaoaptas = false;
        AllEnable.pessemaramacao = false;
        AllEnable.armacaoterreno = false;

        AllEnable.bacelos = false;
        AllEnable.enxertoS1 = false;
        AllEnable.videiraS2 = false;
        AllEnable.videiraS3 = false;
        AllEnable.videiraS4A25 = false;
        AllEnable.videirasmaioR25 = false;
        AllEnable.bacelosileg = false;
        AllEnable.enxertoS1ILEG = false;
        AllEnable.videiraS2ILEG = false;
        AllEnable.videiraS3ILEG = false;
        AllEnable.videiraS4A25ILEG = false;
        AllEnable.videirasmaioR25ILEG = false;

        if (full) {
            AllEnable.legalizavel = false;
            AllEnable.idsitparc = false;
            AllEnable.idsitleg = false;
        }

        this.setState({
            AllEnable,
            AllVisiable,
        });
    };

    // getAllLIst = () => {
    //     this.getlist("busentdistrito");
    //     //this.getlist('InstalacaoVinica');
    //     this.getlist("EntrepostoDropdown");
    //     this.getlist("actividade");
    //     this.getlist("estado");
    //     this.getTipoList();
    // };

    // /* Api chamando dados da tabela */

    // getlist = async (listname) => {
    //     let res = await services.apiCall.requestApi(
    //         "allservice/" + listname + "/GetAll",
    //         combolistrequest,
    //         "post"
    //     );
    //     if (res) {
    //         let all_list = { ...this.state.all_list };
    //         all_list[listname] = res;
    //         this.setState({
    //             all_list,
    //         });
    //     }
    // };

    getTipoList = async () => {
        console.log("554455 getTipo executed");
        let request = {};
        //https://localhost:44397/api/SIVDP/GetAllTipoInstalacao
        let link = "InstalacaoVinica/GetAllTipoInstalacao";
        let res;
        res = await services.apiCall.requestApi(link, request, "post");
        if (res) {
            let all_list = { ...this.state.all_list };
            all_list["tipoInstalacaoList"] = res;
            this.setState(
                {
                    all_list,
                },
                () => {
                    console.log("554455 res ", res);
                }
            );
        }
    };

    // getlist_new = async (listname) => {
    //     //console.log("00011 call 2");

    //     let res = await services.apiCall.requestApi(
    //         listname + "/GetAll",
    //         combolistrequest,
    //         "post"
    //     );
    //     if (res) {
    //         let all_list = { ...this.state.all_list };
    //         all_list[listname] = res;
    //         this.setState({
    //             all_list,
    //         });
    //     }
    // };

    /*  Para fechar pop-up  */

    closePopup = () => {
        $(".left-popup").trigger("click");
        this.updatesel_nev(this.state.sel_nev);
    };

    getrightformdata = (data) => {
        //console.log("right data", data)
        this.setState({
            data: data,
        });
    };

    getcenterformdata = (data) => {
        console.log("00011 center form", data);
        // let formData = {...this.state.formData}
        // formData['entidades']['entidade'] = data
        this.setState({
            data: { ...this.state.data, ...data },
            //formData
        });
    };

    getVasilhaData = (data) => {
        this.setState({
            VasilhaData: data,
        });
    };

    getIVVFormdetails = async (parsed) => {
         let url = "";
        let validate = false;
        let data = {};
        let method = "get";
        let token = "";
        let formData = {};
        const queryParams = queryString.parse(this.props.location.search)
        const cenas = queryParams.idInstalacao
        console.log(cenas , "vvvvvv")
        if(cenas){
            let link = "InstalacaoVinica/ViewInstalacaoVinicaDetalhe";
            let allVasilha = [];
            let request = {
                Filters: {
                    idInstalacaoVinica: cenas,
                },
                SortBy: "",
                IsSortTypeDESC: true,
                IsPagination: true,
                Page: 1,
                PageSize: 100,
            };
            var filter = {"idInstalacaoVinica": cenas}
            let res = await services.apiCall.requestApi(link, filter, "get");
            console.log("the parsed value is...", parsed);
            if (parsed.from === "validateIVV") {
                validate = true;
                // let resIVV = this.props.history.location.state;
                const resIVV = queryString.parse(this.props.location.search);
                if(res != undefined){
                    var codigoIVV = res.codigoIVV;
                }
            console.log("Verificação", resIVV)
            
                this.setState(
                    {
                        data: resIVV,
                    },
                    () => {
                        //this.correctValuesFromDB();
                    }
                );
            } else if (token) {
                //https://localhost:44397/api/SIVDP/InstalacaoVinica/2140
                console.log("spidey senses!");
                //InstalacaoVinica/InstalacaoVinicaList?idInstalacaoVinica=1065
              //  url = `InstalacaoVinica/InstalacaoVinicaList?idInstalacaoVinica=${parsed.idInstalacao}`;
                console.log("url isss", url);
                method = "get";
                token = "getById";
            }
            if (!validate) {
    
                let res = await services.apiCall.requestApi(link, filter, method);
    
                if (res) {
                    if (token === "validate") formData = JSON.parse(res + "");
                    else {
                        formData.entidades = {};
                        formData.entidades.entidade = res;
                    }
    
                    //console.log("can you see me??? response is...", formData);
                    let data =
                        formData && formData.entidades
                            ? formData.entidades.entidade
                            : {};
                    this.setState(
                        {
                            formData,
                            data,
                        },
                        async () => {
                            await this.getAllVasilha();
                            await this.getAllUser();
                         //   this.correctValuesFromDB();
                        }
                    );
                }
            }
        }else{
            this.getQueryParams();
        }
    };

    getQueryParams = () => {
        const query = window.location.search.substring(1);
        const params = query.split('&');
        let queryParams = {};
        
        params.forEach(function(param) {
          let [key, value] = param.split('=');
          key = decodeURIComponent(key);
          value = decodeURIComponent(value || '');  // Tratar valores não definidos
          queryParams[key] = value;
        });
    
        this.GetFields(queryParams);
    };

    GetFields = (dadosCampos) => {
        this.setState(
            {
                data: dadosCampos,
            },
            () => {
                // this.createInstalacaoObject();
            }
        );

        
    }

    getAllUser = async () => {
        //https://localhost:44397/api/InstalacaoVinica/GetUsers
        let link = "InstalacaoVinica/GetUsers";
        let allUser = [];
        let request = {
            idInstalacaoVinica: this.state.data["idInstalacaoVinica"],
        };
        let res = await services.apiCall.requestApi(link, request, "post");
        // console.log("uuuser users ", res.codEntidade);
        if (res) {
            allUser = res;
        }
        this.setState(
            {
                allUser,
            },
            () => {
                //this.correctOwner();
            }
        );
    };

    getAllVasilha = async () => {
        var token = 0;
        const queryParams = queryString.parse(this.props.location.search)
        if(+queryParams.idInstalacao != undefined){
            var token = queryParams.idInstalacao
        }else{
            var token = 0
        }


        if(token != 0){
            console.log(token , "TOKENgetAllVasilha")
            let link = "InstalacaoVinica/ViewInstalacaoVinicaDetalhe";
            let allVasilha = [];
            let allCapacidades = [];
            let request = {
                Filters: {
                    idInstalacaoVinica: token,
                },
                SortBy: "",
                IsSortTypeDESC: true,
                IsPagination: true,
                Page: 1,
                PageSize: 100,
            };
            var filter = {"idInstalacaoVinica": token}
            if(token != 0 && token != null){
                let res = await services.apiCall.requestApi(link, filter, "get");
                console.log("Teste ------ ", res);
    
                // var ArrayTeste = [];
    
                // ArrayTeste.push(res)
    
                // if (ArrayTeste.length > 0){
                //     for (let index = 0; index < ArrayTeste.length; index++) {
                //         var atividade = res.atividade[index].idAtividade;
                //         var descAtividade = res.atividade[index].descricaoAtividade;
                //         $(".idAtive").val(descAtividade)
                //         $(".idAtive").text(descAtividade)
                        
                //     }
                    
                // }
                if (res != undefined) {
                    allVasilha = res.vasilhas;
                    allCapacidades = res;
    
                    this.setState(
                        {
                            allVasilha,
                            allCapacidades
                        },
                        () => {
                            this.vasilhaUsers();
                            this.capacidadeValues();
                        }
                    );
                }
            }
        }  
    };

    vasilhaUsers = () => {
        let allVasilha = [...this.state.allVasilha];
        let vasilhaUserArray = [];
        const queryParams = queryString.parse(this.props.location.search)
        var vascodEntidade = +queryParams.codEntidade
        allVasilha.map((vasilha) => {
            let alreadyExists = false;
            vasilhaUserArray.map((user) => {
                if (vascodEntidade === user.codEntidade) {
                    alreadyExists = true;
                }
            });
            if (!alreadyExists) {
                let obj = {
                    codEntidade: vascodEntidade,
                };
                vasilhaUserArray.push(obj);
            }
        });
        this.setState({
            vasilhaUserArray,
        });
    };

    capacidadeValues = () => {
        let vasilhas = [...this.state.allVasilha];
        let allCapacidades = [...this.state.allCapacidades.capacidadeMaterialVasilhas];
        let allTotal = this.state.allCapacidades.capacidadeTotal;
        let autovidante = 0;
        let balao = 0;
        let balseiro = 0
        let casco = 0;
        let cascos = 0;
        let inox = 0;
        let plastico = 0;
        let cimento = 0;
        let ferro = 0;
        let fibra = 0;
        let subterranea = 0;
        let garrafao = 0;
        let garrafas = 0;
        let isotermica = 0;
        let outro = 0;
        let tonel = 0;
        

        let x = 0;
        let y = 0;
        let leakage = 0;
        let vasilhaOwners = [];
        let capacidade = {};
        let total = 0

        const queryParams = queryString.parse(this.props.location.search)
        var vascodEntidade = +queryParams.codEntidade
        vasilhas.map((obj) => {
            let capacityVariable = obj.capacidadeCalculada
                ? obj.capacidadeCalculada
                : obj.capacidadeComunicada;
            
            let alreadyExists = false;
            vasilhaOwners.map((owner) => {
                if (vascodEntidade === this.state.allUser.codEntidade) {
                    alreadyExists = true;
                }
            });
            if (!alreadyExists) {
                let codEntidade = {
                    codEntidade: vascodEntidade,
                };
                vasilhaOwners.push(codEntidade);
            }
            //total = total + capacityVariable;
        });
        allCapacidades.map((obj) => {
            if (obj.tipoMaterial === "Autovid.") {
                autovidante = obj.capacidade;
            } else if (obj.tipoMaterial === "Balão") {
                balao = obj.capacidade;
            }else if (obj.tipoMaterial === "Inox") {
                inox = obj.capacidade;
            } else if (obj.tipoMaterial === "Balseiro") {
                balseiro = obj.capacidade;   
            } else if (obj.tipoMaterial === "Casco") {
                casco = obj.capacidade;
            } else if (obj.tipoMaterial === "Cascos") {
                cascos = obj.capacidade;
            }else if (obj.tipoMaterial === "Ferro") {
                ferro = obj.capacidade;
            }else if (obj.tipoMaterial === "Fibra") {
                fibra = obj.capacidade;
            }else if (obj.tipoMaterial === "Plástico") {
                plastico = obj.capacidade;
            }else if (obj.tipoMaterial === "Subter.") {
                subterranea = obj.capacidade;
            }else if (obj.tipoMaterial === "Garrafão") {
                garrafao = obj.capacidade;
            }else if (obj.tipoMaterial === "Garrafas") {
                garrafas = obj.capacidade;
            }else if (obj.tipoMaterial === "Isotérm.") {
                isotermica = obj.capacidade;
            }else if (obj.tipoMaterial === "Outro") {
                outro = obj.capacidade;
            }else if (obj.tipoMaterial === "Tonel") {
                tonel = obj.capacidade;
            }else if (obj.tipoMaterial === "Cimento") {
                cimento = obj.capacidade;
            }
            let alreadyExists = false;
            vasilhaOwners.map((owner) => {
                if (vascodEntidade === this.state.allUser.codEntidade) {
                    alreadyExists = true;
                }
            });
            if (!alreadyExists) {
                let codEntidade = {
                    codEntidade: vascodEntidade,
                };
                vasilhaOwners.push(codEntidade);
            }
            total = allTotal;
        });
        leakage =
            this.state.data && this.state.data.franquia
                ? this.state.data.franquia
                : "";

        capacidade["autovidante"] = autovidante;
        capacidade["balao"] = balao;
        capacidade["balseiro"] = balseiro;
        capacidade["casco"] = casco;
        capacidade["cascos"] = cascos;
        capacidade["inox"] = inox;
        capacidade["plastico"] = plastico;
        capacidade["cimento"] = cimento;
        capacidade["ferro"] = ferro;
        capacidade["fibra"] = fibra;
        capacidade["subterranea"] = subterranea;
        capacidade["garrafao"] = garrafao;
        capacidade["garrafas"] = garrafas;
        capacidade["isotermica"] = isotermica;
        capacidade["outro"] = outro;
        capacidade["tonel"] = tonel;
        capacidade["total"] = total;
    
        this.setState(
            {
                capacidade,
                vasilhaOwners,
                leakage,
                total,
            },
            () => {
                console.log(
                    "the capacidade and owners ",
                    capacidade,
                    vasilhaOwners
                );
            }
        );
    };

    correctCheckbox = () => {
        let data = {};
        let checkbox = [];
        checkbox = this.state.data ? this.state.data["checkbox"] : [];
        // checkArray.forEach(checkmark => {
        //     let check = checkmark.toString()
        //     let key = checkboxCheck[check]
        //     checkbox = {...checkbox, [key]:true}
        // })
        data = { ...this.state.data, checkbox };
        this.setState({
            data,
        });
    };

    // correctOwner = () => {
    //     let owner = {};
    //     let users = this.state.allUser ? [...this.state.allUser] : [];
    //     let IdenUser = {};
    //     let displayData = { ...this.state.displayData };

    //     owner["codEntidade"] = this.state.data.owner.codEntidade;
    //     owner["nome"] = this.state.data.owner.nome;
    //     owner["nif"] = this.state.data.owner.ownernif;
    //     owner["tableID"] =
    //         this.state.data.owner.idInstalacaoVinicaProprietario || null;

    //     if (this.state.data.owner.tipoIdentificacao == 1) {
    //         IdenUser["instalacaoDetail"] = "verbal";
    //     } else if (this.state.data.owner.tipoIdentificacao == 2) {
    //         IdenUser["instalacaoDetail"] = "documental";
    //     }
    //     if (this.state.data.owner.codEntidade) {
    //         IdenUser["Instalação"] = this.state.data.owner.ownernif || "";
    //     }

    //     //owner
    //     if (owner.codEntidade) {
    //         displayData["Instalação"] = [{ ...owner }];
    //     } else {
    //         displayData["Instalação"] = [];
    //     }

    //     //user
    //     if (users.length > 0) {
    //         displayData["Utilizadores"] = [...users];
    //     } else {
    //         displayData["Utilizadores"] = [];
    //     }
    //     this.setState({
    //         owner: [{ ...owner }],
    //         displayData,
    //         IdenUser: { ...this.state.IdenUser, ...IdenUser },
    //     });
    // };

    // correctValuesFromDB = () => {
    //     this.correctCheckbox();
    //     this.correctOwner();
    // };

    scrolthis = (sel_nev) => {
        if ($("#" + sel_nev).length)
            $("html, body").animate(
                {
                    scrollTop: $("#" + sel_nev).offset().top - 95, //#DIV_ID is an example. Use the id of your destination on the page
                },
                "slow"
            );
    };

    handleSubmit = async (e, backUrl) => {
        let data = {};
        let res;
        let link = "InstalacaoVinica/SubmeterInstalacao";
        //let link = "InstalacaoVinica/ProcInsertinstalation";

        data = this.createRequestBody();
        console.log("the request to be submitted is ", data);

        if (!data.isValid) {
            toast.error("Por favor, preencha os campos obrigatórios.");
            this.setState({
                checkMandatoryFields: true,
            });
            return;
        }
        console.log("Data: ", data);
        console.log("Data.Request", data.request);
        if(data.request.idInstalacaoVinica == 0){
            delete data.request.checkbox;
            delete data.request.entreposto;
            delete data.request.idAtividade;
            delete data.request.idTipoInstalacao;
            delete data.request.idUtilizadorInstalacao
            data.request.idEstado = null;
            data.request.localArmazenagem = parseInt($("#localArmazenagem :selected").val())
            data.request.NumeroLicIndustrial = $("#numeroLicIndustrial").val()
            data.request.CodigoLicenciamentoIndustrial = $("#numeroLicIndustrial").val()
        }
        var dis = parseInt($("#Distrito :selected").val()) < 10 ? "0" + $("#Distrito :selected").val() : $("#Distrito :selected").val()
        var con = parseInt($("#Concelho :selected").val()) < 10 ? "0" + $("#Concelho :selected").val() : $("#Concelho :selected").val()
        var freg = parseInt($("#Freguesia :selected").val()) < 10 ? "0" + $("#Freguesia :selected").val() : $("#Freguesia :selected").val()
       
        data.request.DICOFRE = dis + con + freg
        res = await services.apiCall.requestApi(link, data.request, "post");
        console.log(res);
        if (res) {
            let queryParam = {};
            console.log("response to create api is ", res);
            if (backUrl) {
                console.log("BackURL: ", backUrl)
                this.props.history.push({
                    pathname: backUrl,
                });
            } else {
                if (!this.state.isInEdit) {
                    this.props.history.push({
                        pathname: "/inseririnstalacaovínica",
                        search: `idInstalacao=${parseInt(res)}`,
                        //state: { entidade_id: row.codEntidade, idWS: row['código_de_Instalação'] }
                    });
                    queryParam = {
                        idInstalacao: parseInt(res),
                    };
                }
                await this.getIVVFormdetails(queryParam);
                let isInEdit = true;
                this.setState({
                    isInEdit,
                });
            }
        }
    };
    /*

Armazenamento
:
1
ArmazenamentoProdutocabado
:
1
Engarrafamento
:
1
LicenciamentoIndustrial
:
1
Vinificacao
:
1
etar
: */
    createInstalacaoObject = () => {
        let request = {};
        let todayDate = new Date();
        console.log(this.state.data)
        request["instalacao"] = {};
        createIntalacaoPayload.map((key) => {
            request["instalacao"][key] = this.state.data[key];
            if (key === "coddis" || key === "codcon" || key === "codfrg") {
                let value = +this.state.data[key];
                if (
                    value < 10 &&
                    this.state.data[key] &&
                    this.state.data[key].length < 2
                ) {
                    request["instalacao"][key] = "0" + this.state.data[key];
                }
            } else if (key === "idUtilizadorInstalacao") {
                request["instalacao"][key] = 1;
            } else if (key === "codigoIVV") {
                request["instalacao"][key] = this.state.data["codigoIVV"];
            } else if (key === "lugar") {
                request["instalacao"][key] = this.state.data["lugar"];
            // } else if (key === "codigoPostalExtenso") {
            //     request["instalacao"][key] = this.state.data["codigoPostalExtenso"];
            } else if (key === "numeroLicIndustrial") {
                if(request.instalacao.checkbox.LicenciamentoIndustrial === 0){
                    request["instalacao"][key] = "";
                }
                else{
                    request["instalacao"][key] = this.state.data["NumeroLicIndustrial"];
                }
            } else if (key === "LicenciamentoIndustrial") {
                if(request.instalacao.checkbox.LicenciamentoIndustrial == 1){
                    request["instalacao"][key] = true;
                }else{
                    request["instalacao"][key] = false;
                }
            } else if (key === "Etar") {
                if(request.instalacao.checkbox.Etar == 1){
                    request["instalacao"][key] = true;
                }else{
                    request["instalacao"][key] = false;
                }
            } else if (key === "criadoPor") {
                request["instalacao"][key] = window.localStorage.getItem('username');
            } else if (key === "geocodigo") {
                request["instalacao"][key] = this.state.data["geocodigo"]
                    ? parseInt(this.state.data["geocodigo"])
                    : 0;
            } else if (key === "areaCoberta") {
                request["instalacao"][key] = this.state.data["areaCoberta"]
                    ? parseInt(this.state.data["areaCoberta"])
                    : 0;
            } else if (key === "idEstado") {
                if(this.state.data.estado == "Ativo" || this.state.data.estado == 1){
                    request["instalacao"][key] = 1;
                }
                else if(this.state.data.estado == "Inativo" || this.state.data.estado == 2){
                    request["instalacao"][key] = 2;
                }
            } else if (key === "idTipoInst") {
                console.log(this.state.data)
                console.log(this.state.data["tiposInstalacao"])
                request["instalacao"][key] = this.state.data["tiposInstalacao"]
                    ? this.state.data["tiposInstalacao"]
                    : [];
            } else if (key === "idAtive") {
                console.log(this.state.data)
                console.log(this.state.data["atividades"])
                request["instalacao"][key] = this.state.data["atividades"]
                    ? this.state.data["atividades"]
                    : [];
            } else if (key == "localArmazenagem") {
                if(this.state.data.localArmazenagem == "Gaia" || this.state.data.localArmazenagem == "1"){
                    request["instalacao"][key] = 1;
                }
                if(this.state.data.localArmazenagem == "Douro" || this.state.data.localArmazenagem == "2"){
                    request["instalacao"][key] = 2;
                }
                if(this.state.data.localArmazenagem == "Resto do País" || this.state.data.localArmazenagem == "3"){
                    request["instalacao"][key] = 3;
                }
                if(this.state.data.localArmazenagem == "Outro País" || this.state.data.localArmazenagem == "4"){
                    request["instalacao"][key] = 4;
                }
            } else if(key == "loggedUser") {
                request["instalacao"][key] = localStorage.getItem('username');
            }
            
            else if (key === "dataCriado") {
                if (this.state.isInEdit) {
                    //dataCriado from the DB
                    request["instalacao"][key] = this.state.data[key] || null;
                } else {
                    request["instalacao"][key] =
                        moment(todayDate).format("YYYY-MM-DD");
                }
            } else if (key === "dataModificado") {
                request["instalacao"][key] = todayDate;
            } else if (key === "idInstalacaoVinica") {
                request["instalacao"][key] = this.state.data[key]
                    ? this.state.data[key]
                    : 0;
            } else if (key === "observacoes") {
                request["instalacao"][key] = this.state.data["observacoes"]
            } else if (key === "codigoPostal") {
                request["instalacao"][key] = this.state.data["codigoPostal"];
            } else if (key === "entreposto") {
                request["instalacao"][key] = this.state.data["entreposto"]
                    ? this.state.data["entreposto"]
                    : [];
                } else if (key === "DICOFRE") {
                    console.log(this.state.coddis)
                    request["instalacao"][key] = request["instalacao"].coddis +
                        request["instalacao"].codcon +
                        request["instalacao"].codfrg;
            } else if (key === "checkbox") {
                request["instalacao"][key] = this.state.data[key]
                    ? this.state.data[key]
                    : [];
            } else if (key === "instalacaoVinica") {
                request["instalacao"][key] = this.state.data["designacaoSocial"]
                    ? this.state.data["designacaoSocial"]
                    : null;
            } else if (key === "codEntrFiscal") {
                request["instalacao"][key] = this.state.data["codEntrFiscal"];
                // if (this.state.data["codEntrFiscal"]){
                //     request["instalacao"]["selfEntreposto"] = true;
                    
                // }else {
                //     request["instalacao"]["selfEntreposto"] = false;
                // }
            
            } else if (
                request["instalacao"][key] === undefined ||
                request["instalacao"][key] === ""
            ) {
                request["instalacao"][key] = null;
            }

            if (!this.state.isInEdit) {
                delete request["instalacao"].dataModificado;
            }

        });
        // request["instalacao"]["dicofre"] =
        //     request["instalacao"].coddis +
        //     request["instalacao"].codcon +
        //     request["instalacao"].codfrg;
        // request["instalacao"]["dicofre"] = this.state.data["dicofre"]
        //     ? this.state.data["dicofre"].trim()
        //     : "";
        delete request["instalacao"].coddis;
        delete request["instalacao"].codcon;
        delete request["instalacao"].codfrg;
        // request["numeroEntrepostoFiscal"] = this.state.data[
        //     "numeroEntrepostoFiscal"
        // ]
        //     ? this.state.data["numeroEntrepostoFiscal"].trim()
        //     : this.state.data["numeroEntrepostoFiscal"];
        return request;
    };

    createOwnerObject = () => {
        let ownerObj = {};
        let tab = "Instalação";
        let { IdenUser } = this.state;
        const queryParams = queryString.parse(this.props.location.search)
        var vascodEntidade = +queryParams.codEntidade
        console.log("state owner is ", this.state.displayData);
        owner.map((key) => {
            if (key === "codEntidade") {
                if (this.state.owner.length > 0) {
                    console.log("555444 ");
                    ownerObj[key] = "" +vascodEntidade;
                } else {
                    ownerObj[key] = null;
                }
            } else if (key === "nome") {
                if (this.state.owner.length > 0) {
                    ownerObj[key] = this.state.owner[0][key];
                } else {
                    ownerObj[key] = null;
                }
            } else if (key === "ProprietarioPrincipal") {
                if (this.state.owner.length > 0) {
                    ownerObj[key] = true;
                } else {
                    ownerObj[key] = false;
                }
            } else if (key === "TipoIdentificacao") {
                if (
                    IdenUser[tab] &&
                    IdenUser["instalacaoDetail"] === "verbal"
                ) {
                    ownerObj[key] = 1;
                } else if (
                    IdenUser[tab] &&
                    IdenUser["instalacaoDetail"] === "documental"
                ) {
                    ownerObj[key] = 2;
                }
            }
        });
        return ownerObj;
    };

    checkNullInOject = (obj) => {
        Object.keys(obj).map((key) => {
            if (obj[key] === undefined) {
                obj[key] = null;
            }
        });
        return obj;
    };

    checkMandatory = (obj, name) => {
        let isValid = true;
        if (name === "mainForm") {
            mandatoryFields.mainForm.map((key) => {
                if (obj[key] === null) {
                    isValid = false;
                    console.log("zzz main form");
                }
            });
        } else if (name === "owner") {
            mandatoryFields.owner.map((key) => {
                if (obj[key] === null) {
                    isValid = false;
                    console.log("zzz owner form");
                }
            });
        }
        return isValid;
    };

    createRequestBody =     () => {
        let request = {};
        //let checkbox = {};
        //let ownerObj = {};
        let isValid = true;

        //instalacao object
        request = this.createInstalacaoObject();
        request["instalacao"] = this.checkNullInOject(request["instalacao"]);
        isValid = this.checkMandatory(request["instalacao"], "mainForm");
        console.log("zzz request is ", request);
        if (!isValid) {
            return {
                isValid: false,
                request: {},
            };
        }

        //checkbox object
        //checkbox = this.createCheckboxObject()
        //checkbox = this.checkNullInOject(checkbox)

        //request["instalacao"]["checkbox"] = [...checkbox]
        //request["instalacao"]["entreposto"] = [2104]

        //owner object
        /*ownerObj = this.createOwnerObject();
        isValid = this.checkMandatory(ownerObj, "owner");
        if (!isValid) {
            return {
                isValid: false,
                request: {},
            };
        }
        ownerObj = this.checkNullInOject(ownerObj);

        request["instalacao"]["owner"] = { ...ownerObj };
        */
        return {
            isValid: true,
            request: request["instalacao"],
        };
    };

    //-------------------------------------------------------------handle sumbit redesign

    // handleSubmit = (e, backUrl) => {
    //     let data = {}
    //     let link = 'SIVDP/ProcInsertinstalation'
    //     const parsed = queryString.parse(this.props.location.search)
    //     this.setState({
    //         checkMandatoryFields: true
    //     }, () => {
    //         data = this.filterDataToSubmit()
    //         if(!data.checkBefore) return
    //         delete data.checkBefore
    //         services.apiCall.requestApi(link, data, 'post')
    //             .then(res => {
    //                 console.log("it worked inside yes")
    //                 //toast.success(res.message)
    //                 if(!parsed.idWS && !parsed.from) {
    //                     toast.success("Successo!")
    //                 }
    //                 console.log("response is.... ", res)
    //             })
    //             .catch(error => {
    //                 console.log("error is ", error)
    //             })
    //         if(backUrl) {
    //             this.props.history.push({
    //                 pathname: backUrl
    //             })
    //         }
    //     })
    // }

    //-----------------------------------------------------------fill them values

    // fillThemValues = () => {

    //     const testData = {
    //         DescricaoProprietario: "test",
    //         EntidadePrincipal: 1,
    //         IDEntidade: null,
    //         IDIdentificacaoProprietario: 1,
    //         ano: "2020      ",
    //         areaCoberta: null,
    //         capacidadeVenda: 0,
    //         codEntrFiscal: "test",
    //         codInstalacao: "0",
    //         //codcon: "15",
    //         //coddis: "18",
    //         //codfrg: "04",
    //         //codigoPostalExtenso: "1111-118",
    //         //designacaoSocial: "test",
    //         fax: null,
    //         geocodigo: null,
    //         id: null,
    //         idAtividade: 4,
    //         idEntreposto: 1,
    //         idInstalacaoVinica: 0,
    //         idTipoInstalacao: 1,
    //         idUtilizadorInstalacao: 1,
    //         licenceIndustrial: null,
    //         lugar: null,
    //         //morada: null,
    //         numeroEntrepostoFiscal: null,
    //         observacoes: this.state.data.desparc ? this.state.data.desparc : null,
    //         telefone: null,
    //         codInstalacao: null,
    //         total: 1000,
    //         instalacaoVinica: "test",
    //     }
    //     let dataObject = {}

    //     let dataArray = [
    //         "designacaoSocial",
    //         "telefone",
    //         "fax",
    //         "areaCoberta",
    //         "geocodigo",
    //         "lugar",
    //         "codigoPostalExtenso",
    //         "morada",
    //         "coddis", //
    //         "codcon", //
    //         "codfrg",
    //         "idAtividade",
    //         "idEntreposto",
    //     ]
    //     dataArray.map(key => {

    //         dataObject[key] = this.state.data[key]
    //         if(key === "coddis" || key === "codcon" || key === "codfrg") {
    //             let value = +this.state.data[key]
    //             if(value < 10) {
    //                 dataObject[key] = "0" + this.state.data[key]
    //             }
    //         }
    //         if(dataObject[key] == undefined) {
    //             dataObject[key] = null
    //         }
    //     })
    //     let finalData = {...testData, ...dataObject}
    //     //let date = new Date()
    //     //finalData["DateCriado"] = moment(date).format('YYYY-MM-DD')
    //     console.log("the data that we sumbmit ", finalData)
    //     return finalData

    // }

    //------------------------------------------------------------fill data to submit

    // filterDataToSubmit = () => {
    //     let data = {...this.state.data}
    //     let dataToSubmit = {}
    //     let isValid = null
    //     const parsed = queryString.parse(this.props.location.search)
    //     console.log("old data is...", data)
    //     console.log("old state data is...", this.state.data)
    //     let submitArray = [
    //         "idInstalacaoVinica",
    //         "codInstalacao",
    //         "instalacaoVinica", //
    //         "ano",
    //         "designacaoSocial", //
    //         "morada", //
    //         "lugar",
    //         "codigoPostalExtenso", //
    //         "coddis", //
    //         "codcon", //
    //         "codfrg", //
    //         "idAtividade",
    //         "idEntreposto",
    //         "idTipoInstalacao", //
    //         "capacidadeVenda",
    //         "total", //
    //         "areaCoberta",
    //         "geocodigo",
    //         "codEntrFiscal",
    //         "telefone",
    //         "fax",
    //         "id",
    //         "numeroEntrepostoFiscal",
    //         "licenceIndustrial",
    //         "observacoes",
    //         "idUtilizadorInstalacao", //
    //         "IDEntidade", //
    //         "EntidadePrincipal",
    //         "IDIdentificacaoProprietario", //
    //         "DescricaoProprietario", //
    //     ]

    //     console.log("parsed is ...... ", parsed)
    //     if(parsed.idWS){
    //         //console.log("chal gai ander wali")
    //         submitArray.map(key => {
    //         dataToSubmit[key] = data[key]
    //         if(key === "observacoes"){
    //             dataToSubmit[key] = this.state.data.desparc
    //         }
    //         else if(key === "codInstalacao"){
    //             if(parsed.idWS){
    //                 console.log("parsed idWS")
    //                 dataToSubmit[key] = this.state.data.idInstalacaoVinica.toString()
    //             }
    //             // else
    //             // dataToSubmit[key] = "0"
    //         }
    //         else if(dataToSubmit[key] == false || dataToSubmit[key] == undefined) {
    //             dataToSubmit[key] = null
    //         }
    //         })
    //     }
    //     else {
    //         //toast.error("New Installation")
    //         dataToSubmit = this.fillThemValues()
    //     }

    //     //isValid = this.validateMandatoryFields(dataToSubmit)
    //     console.log("new data is....", dataToSubmit)
    //     dataToSubmit["DataCriado"] = moment(new Date()).format("YYYY-MM-DD")
    //     isValid  = this.validateMandatoryFields(dataToSubmit)
    //     console.log("the check value is ", isValid)
    //     if(isValid) {
    //         console.log("dta final is yes it worked in the if block", dataToSubmit)
    //         dataToSubmit.checkBefore = true
    //         return dataToSubmit
    //     }
    //     else {
    //         //toast.error("Mandatory fields missing")
    //         let dataNotGone = {}
    //         dataNotGone.checkBefore = false
    //         return dataToSubmit
    //     }

    // }

    validateMandatoryFields = (data) => {
        let isValid = true;
        //function to check mandatory fiels
        console.log("what i am checking is ", data);
        mandatoryFields.map((key) => {
            if (
                data[key] == null ||
                data[key] == undefined ||
                data[key] == false
            ) {
                isValid = false;
            }
        });
        return isValid;
    };
    /* Deletar linha da tabela de dados */
    handleDelete = (status) => {
        //console.log("status", status)
    };

    updatesel_nev = (sel_nev) => {
        this.setState({
            sel_nev,
        });
        if ($("#" + sel_nev).length) {
            $("html, body").animate(
                {
                    scrollTop: $("#" + sel_nev).offset().top - 95, //#DIV_ID is an example. Use the id of your destination on the page
                },
                "slow"
            );
        }
    };

    handleHistoryToggle = (e) => {
        this.setState((prevState) => {
            return {
                historyToggle: !prevState.historyToggle,
            };
        });
    };

    getdisplayDataArray = (data, IdenUser) => {
        console.log("the data we want the owner to be ", data);
        let newData = { ...data };
        let displayData = { ...data };
        this.setState(
            {
                owner: newData["Instalação"],
                users: newData["Utilizadores"],
                displayData,
                IdenUser,
            },
            () => {
                console.log(
                    "change of owner ",
                    this.state.owner,
                    this.state.IdenUser
                );
            }
        );
    };

    getNifArray = (nifArrayVasilah) => {
        this.setState({
            nifArrayVasilah,
        });
    };
    /*  Para renderizar o conteúdo html da página   */

    setivvFormData(type, value) {}

    render() {
        console.log("00011 in inserir", this.state.data);
        let params = queryString.parse(window.location.search);
        let id = params.id ? params.id : "";
        return (
            <div className="dashboard">
                <FormnavBar
                    isInEdit={this.state.isInEdit}
                    to="/instalacaovinica"
                    noCancelarEVoltarBtn={this.state.id ? false : true}
                    // handleDelete={(status) => this.handleDelete(status)}
                    showDelete={true}
                    handleSubmit={(data, url) => this.handleSubmit(data, url)}
                    type="instalacoesvinicas"
                    headName={this.state.headName}
                    // handleHistoryToggle={(e) => this.handleHistoryToggle(e)}
                />
                <div className="full-container edit-ward">
                    <WizardLeft
                        date={new Date()}
                        id={this.state.id ? this.state.id : null}
                        updatesel_nev={(sel_nev) => this.updatesel_nev(sel_nev)}
                        sel_nev={this.state.sel_nev}
                        type="instalaçõesinsert"
                    />
                    <WizardVínica
                        id={this.state.id}
                        ivvFormData={this.state.data}
                        //setivvFormData={this.setivvFormData}
                        data={this.state.data || {}}
                        date={new Date()}
                        all_list={this.state.all_list}
                        closePopup={() => this.closePopup()}
                        handleHistoryToggle={() => this.handleHistoryToggle()}
                        getcenterformdata={(data) =>
                            this.getcenterformdata(data)
                        }
                        updatesel_nev={(sel_nev) => this.updatesel_nev(sel_nev)}
                        isVisiable={(name) => this.isVisiable(name)}
                        isEnable={(name) => this.isEnable(name)}
                        checkMandatoryFields={this.state.checkMandatoryFields}
                        getVasilhaData={(data) => this.getVasilhaData(data)}
                        historyToggle={this.state.historyToggle}
                        displayData={this.state.displayData}
                        getNifArray={(data) => this.getNifArray(data)}
                        isInEdit={this.state.isInEdit}
                        idInstalacaoVinica={
                            this.state.data["idInstalacaoVinica"] || 0
                        }
                        //closePopup={() => this.closePopup()}
                        getAllVasilha={() => this.getAllVasilha()}
                        allVasilha={this.state.allVasilha || []}
                        capacidade={this.state.capacidade || {}}
                        vasilhaOwners={this.state.vasilhaOwners || []}
                    />

                    <VínicaRightPanel
                        isInEdit={this.state.isInEdit}
                        date={new Date()}
                        Parcel={this.state.displayData}
                        closePopup={() => this.closePopup()}
                        handleSubmit={(data) => this.getrightformdata(data)}
                        IdenUser={this.state.IdenUser}
                        getdisplayDataArray={(data, IdenUser) =>
                            this.getdisplayDataArray(data, IdenUser)
                        }
                        idInstalacaoVinica={
                            this.state.data["idInstalacaoVinica"] || 0
                        }
                        leakage={this.state.leakage || 0}
                        vasilhaUserArray={this.state.vasilhaUserArray || []}
                        checkMandatoryFields={this.state.checkMandatoryFields}
                    />
                </div>
            </div>
        );
    }
}

export default withRouter(InserirInstalacaoVínica);
